import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GrupoBotonesComponent } from 'src/app/components/botones/grupo-botones/grupo-botones.component';
import { ButtonModule } from 'primeng/button';
import { ValidacionBotonComponent } from './validacion-boton/validacion-boton.component';

@NgModule({
    declarations: [ 
        GrupoBotonesComponent,
        ValidacionBotonComponent
    ],
    exports: [ 
        GrupoBotonesComponent,
        ValidacionBotonComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
    ],
    providers: []
})
export class BotonesActionModule { }
